import axiosInstance from './axiosInstance';

const CENTRAL_DB_BASE = import.meta.env.VITE_CENTRAL_DB_API_URL as string | undefined;

export interface SaleslistImportRowPayload {
  title?: string;
  companyName?: string;
  status?: string;
  verkochtDoor?: string;
  admin?: string;
  profession?: string;
  expectedStartDate?: string;
  description?: string;
  locationCity?: string;
  primaryContactName?: string;
  primaryContactPhone?: string;
  sa?: boolean;
  notes?: string;
  wageType?: string;
  baseRate?: number;
}

export interface SaleslistImportLog {
  level: 'info' | 'warn' | 'error';
  message: string;
}

export interface SaleslistImportRowResult {
  index: number;
  ok: boolean;
  opportunityId?: string;
  logs: SaleslistImportLog[];
}

export interface SaleslistImportResultDto {
  total: number;
  success: number;
  failed: number;
  results: SaleslistImportRowResult[];
}

export async function importSaleslistRows(rows: SaleslistImportRowPayload[]): Promise<SaleslistImportResultDto> {
  const url = CENTRAL_DB_BASE
    ? `${CENTRAL_DB_BASE.replace(/\/$/, '')}/saleslist/opportunities/import`
    : '/saleslist/opportunities/import';

  const { data } = await axiosInstance.post(url, { rows });
  return data as SaleslistImportResultDto;
}
